<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-05-13 16:48:08
 * @Description: 设备信息
 * @LastEditors: Please set LastEditors
-->
<template>
  <div
    class="h-100 position-absolute equpment"
    :style="{ left: isShowBasicCom ? '405px' : '35px' }"
    v-drag
  >
    <div class="business_dialog_title m-b-5 text-color-white">
      <span class="fz-14">设备信息</span>
      <span class="iconfont icon-close cur-pointer close_icon r" @click="closeDialog"></span>
    </div>
    <el-tabs :tab-position="tabPosition" class="equpment_tabs w-100">
      <el-tab-pane label="设备台账">
        <DeviceLedger class="h-100"></DeviceLedger>
      </el-tab-pane>
      <el-tab-pane label="管道数据">
        <PipelineData class="h-100"></PipelineData>
      </el-tab-pane>
      <el-tab-pane label="设备缺陷">
        <EquipmentDefects class="h-100"></EquipmentDefects>
      </el-tab-pane>
      <el-tab-pane label="工单信息"></el-tab-pane>
      <el-tab-pane label="检修记录"></el-tab-pane>
      <el-tab-pane label="两票-工作票">
        <TwoVotes></TwoVotes>
      </el-tab-pane>
      <el-tab-pane label="两票-操作票">
        <TwoVotes class="h-100"></TwoVotes>
      </el-tab-pane>
      <el-tab-pane label="运行日常工作"></el-tab-pane>
      <el-tab-pane label="设备异动记录"></el-tab-pane>
      <el-tab-pane label="工器具登记"></el-tab-pane>
      <el-tab-pane label="工器具借出归还"></el-tab-pane>
      <el-tab-pane label="消防和防汛物资"></el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
// 设备台账
const DeviceLedger = () => {
  return import('./components/DeviceLedger')
}
// 管道数据查看
const PipelineData = () => {
  return import('./components/PipelineData')
}
// 设备缺陷管理
const EquipmentDefects = () => {
  return import('./components/EquipmentDefects')
}
// 两票集成
const TwoVotes = () => {
  return import('./components/TwoVotes')
}
export default {
  props: ['isShowBasicCom'],
  components: {
    DeviceLedger,
    PipelineData,
    EquipmentDefects,
    TwoVotes,
  },
  data() {
    return {
      fromData: {},
      tabPosition: 'left',
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeComponent', 'EquipmentInfo')
    },
  },
}
</script>
<style lang="scss" scoped>

// @import '../../css/semitransparent.scss';
@import '../../../css/index.scss';
.equpment {
  height: 600px;
  width: 900px;
  top: 66px;
  padding: 10px;
  border-radius: 4px;
  z-index: 99;
  background-color: rgba(46, 107, 176, 0.5) !important;
  &_tabs {
    height: calc(100% - 30px);
  }
}
/deep/.el-form-item {
  margin-bottom: 5px;
}
/deep/.el-tabs__content,
/deep/.el-tab-pane {
  height: 100%;
}
/deep/ .el-table {
  thead th {
    padding: 0px;
  }
  &__body-wrapper {
    height: calc(100% - 25px);
    overflow-y: scroll;
  }
  &__expanded-cell {
    padding: 0px 10px;
    padding-left: 20px;
  }
}
/deep/.el-table__expanded-cell {
  background-color: transparent !important;
  padding: 0 10px;
}
.close_icon {
  z-index: 1;
}

</style>
